import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const ConfirmationDialog = ({ open, handleConfirm, handleCancel, title, message, confirmActionButtonLabel, confirmActionButtonColor, cancelActionButtonColor }) => (

          <Dialog
            open={open}
            onClose={handleCancel}
            aria-labelledby='confirmation-dialog-title'
            aria-describedby='confirmation-dialog-description'
          >
            <DialogTitle id='confirmation-dialog-title'>
              {title}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='confirmation-dialog-description'>
                {message}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant='outlined'
                onClick={handleCancel}
                color={cancelActionButtonColor || 'secondary'}
              >
                Cancel
              </Button>
              <Button
                variant='contained'
                onClick={handleConfirm}
                color={confirmActionButtonColor || 'primary'}
                autoFocus
              >
                {confirmActionButtonLabel}
              </Button>
            </DialogActions>
          </Dialog>
  )

export default ConfirmationDialog